import type { TRPCClientError } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import type { TRPCRouter } from "~/trpc/router";

export const { TRPCProvider, useTRPC } = createTRPCContext<TRPCRouter>();

export type ApiError = TRPCClientError<TRPCRouter>;

export function isTRPCClientError(cause: unknown): cause is ApiError {
	return (
		typeof cause === "object" &&
		cause !== null &&
		"data" in cause &&
		// biome-ignore lint/suspicious/noExplicitAny: safe to use here
		typeof (cause as any).data?.code === "string" &&
		"message" in cause &&
		typeof cause.message === "string"
	);
}
